import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Background from "../../components/Background/Background";
import ScreenNavbar from "../../components/ScreenNavbar/ScreenNavbar";
import { ConfigState } from "../../context/ConfigContext";
import { SDKInstanceState } from "../../context/SdkInstanceContext";
import { SDKParamsState } from "../../context/SdkParmasContext";
import { WorkPlatformDetailsState } from "../../context/WorkPlatformDetailsContext";
import { LoaderWithStatusState } from "../../context/LoaderWithStatusContext";
import { LoaderState } from "../../context/LoaderContext";
import Loader from "../../components/Loader/Loader";
import LoaderWithStatus from "../../components/LoaderWithStatus/LoaderWithStatus";
import { isEmpty } from "../../utils/sdk_utils";
import copyIcon from "../../assets/images/copy_icon.svg";
import refreshIcon from "../../assets/images/refresh_icon.svg";
import { THIRD_PARTY_OTP_STEP1, THIRD_PARTY_OTP_STEP2 } from "../../constants/URLConstants";
import "./ThirdPartyOTPStep1.scss";
import { useGetRedirectAuthFlow } from "../../utils/CustomHooks/useGetRedirectAuthFlow";

 const OTP_EXPIRE_SECONDS = 300;
 const OTP_WARNING_SECONDS = 30;

// const OTP_EXPIRE_SECONDS = 10;
// const OTP_WARNING_SECONDS = 3;



function ThirdPartyOTPStep1() {
  const params = useParams();
  const navigate = useNavigate();
  const { configuration } = ConfigState();
  const { sdkInstance } = SDKInstanceState();
  const { sdkParams } = SDKParamsState();
  const { workplatformDetails } = WorkPlatformDetailsState();
     const [platformDetail] = useState(
      workplatformDetails[params.workplatformid]
      );
  const { loaderWithStatus } = LoaderWithStatusState();
  const { loader, dispatchLoaderContext } = LoaderState();
  const { isConnectLoader } = LoaderWithStatusState();
  const [loaderMsgConfig, setLoaderMsgConfig] = useState({});
  const [config, setConfig] = useState({});
  const [secondsLeft, setSecondsLeft] = useState(OTP_EXPIRE_SECONDS);
  const [copied, setCopied] = useState(false);
  const [verificationCode, setVerificationCode] = useState();
  const [authorisationId, setAuthorisationId] = useState();
  const location = useLocation();
  const timerRef = useRef();
  
  const redirectAuthFlow = useGetRedirectAuthFlow(platformDetail.id, platformDetail.name || null, sdkParams, workplatformDetails);
  

  async function generateVerificationCode() {
    dispatchLoaderContext(true);
    const [otp, authId] = await redirectAuthFlow("phyllo_otp_flow");
    setVerificationCode(otp)
    setAuthorisationId(authId)
    dispatchLoaderContext(false);
  }
  
  useEffect(() => {
   if (location.state ) {
      setVerificationCode(location.state?.otp)
      setAuthorisationId(location.state?.authId)
      dispatchLoaderContext(false)
   }
  },[])

  useEffect(() => {
    if (secondsLeft === 0) return;
    timerRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [secondsLeft]);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60).toString().padStart(2, "0");
    const s = (secs % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleCopy = () => {
    const doNavigate = () => navigate(`/${THIRD_PARTY_OTP_STEP2}/${params.workplatformid}`, { state: { otp: verificationCode, authId: authorisationId , codeCopied: true } });
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(verificationCode)
        .then(() => setCopied(true))
        .catch(() => fallbackCopy());
    } else {
      fallbackCopy();
    }
    setTimeout(() => setCopied(false), 1500);
    doNavigate();
  };

  function fallbackCopy() {
    const textArea = document.createElement("textarea");
    textArea.value = verificationCode;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setCopied(true);
    } catch (err) {
      alert('Failed to copy');
    }
    document.body.removeChild(textArea);
  }

  const goBack = () => {
    navigate(-1);
  };

  const handleGenerateNewCode = () => {
    setVerificationCode(generateVerificationCode());
    setSecondsLeft(OTP_EXPIRE_SECONDS);
  };

  if (loader) {
    if (isConnectLoader && !isEmpty(loaderMsgConfig)) {
      return (
        <LoaderWithStatus
          message={loaderMsgConfig.title?.replace("{{PlatformName}}", platformDetail.name)}
          platform={platformDetail.name}
        />
      );
    }
    return <Loader />;
  }

  return (
    <>
      <Background />
      <div className="row col-lg-3 col-md-12 col-sm-12 col-12 m-auto white-screen">
        <ScreenNavbar
          className=""
          backURL={-1}
          screenName={THIRD_PARTY_OTP_STEP1}
          workplatformDetails={{
            workplatformId: platformDetail?.id,
            workplatformName: platformDetail?.name,
          }}
        />
        <div className="otp-step1-main-container">
          <div className="otp-step1-header-row">
            <span className="otp-step1-step">STEP 1 of 2</span>
          </div>
          <div className="otp-step1-instructions">
            <b>Tap on Copy code</b>
            <div className="otp-step1-sub">
              Tap the Copy code button to copy your unique verification code
            </div>
          </div>
          <div className="otp-step1-code-container">
            <div className="otp-step1-code-label">Your verification code</div>
            <div className={`otp-step1-code${secondsLeft === 0 ? " otp-step1-code-disabled" : ""}`}>{verificationCode}</div>
            {secondsLeft > 0 ? (
              <div className={`otp-step1-expiry${secondsLeft <= OTP_WARNING_SECONDS ? " otp-step1-expiry-warning" : ""}`}>
                Code expires in <span className="otp-step1-expiry-timer">{formatTime(secondsLeft)}</span>
              </div>
            ) : (
              <div className="otp-step1-expired">
                <button className="otp-step1-generate-btn" onClick={handleGenerateNewCode}>
                  <img src={refreshIcon} alt="refresh" className="otp-step1-refresh-icon" />
                  <span>Generate new code</span>
                </button>
              </div>
            )}
          </div>
         <div className="row mb-12  col-12 m-auto text-center retry-button-div">
            <button
              className={`primary-btn mb-2${secondsLeft === 0 ? " otp-step1-copy-btn-disabled" : ""}`}
              onClick={handleCopy}
              disabled={secondsLeft === 0}
            >
              <img src={copyIcon} alt="copy" className="otp-step1-copy-icon" style={{ marginRight: "8px", verticalAlign: "middle" }} />
              Copy Code
            </button>
            <button
              className="secondary-btn"
              onClick={goBack}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ThirdPartyOTPStep1; 
